module.exports = __webpack_public_path__ + "static/media/SocialPiper-Header.00e0dff0.jpg";